import treatment from './images/treatment.png'
import vaccine from './images/vaccine-icon.png'
import pethealth from './images/pethealth.png'
import lobarotory from './images/laboratory.png'

const services = [
    {
        name: "Treatment",
        paragraph: "lorem sa fdf asdf",
        Image: treatment
    },

    {
        name: "Vaccine",
        paragraph: "lorem sa fdf asdf",
        Image: vaccine
    },

    {
        name: "Pethealth",
        paragraph: "lorem sa fdf asdf",
        Image: pethealth
    },

    {
        name: "Lobarotory",
        paragraph: "lorem sa fdf asdf",
        Image: lobarotory
    },

]

export default services;